import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductPriceListSurcharge', request)
}

async function put(request) {
    return await putMethod('/api/ownProductPriceListSurcharge', request)
}

async function post(body) {
    return await postMethod('/api/ownProductPriceListSurcharge', body)
}

export {get, put, post}
